import React from 'react';

import { useAppSelector } from '../../../../components/hooks';
import { LayoutCoordinateVisuals } from '../../../../library/layout-geometry/LayoutCoordinateVisuals';
import {
  getCalculatedCeilingTrays,
  getCalculatedInsertionCeilingTray,
} from '../../../../store/selectors/ceilingTraySelectors';
import { getActiveCeilingMode } from '../../../../store/selectors/layoutVisualOptionsSelectors';
import { useAutoInvalidateOnChange } from '../../../hooks/invalidation-hooks';
import { useTrayStyleCalculator } from '../../polygon-rendering/common/style';
import { CeilingTrayVisual } from './CeilingTrayVisual';

export function CeilingTraysController() {
  const calculatedTrays = useAppSelector(getCalculatedCeilingTrays);
  const insertionTrayAndGeometry = useAppSelector(getCalculatedInsertionCeilingTray);

  const getStyle = useTrayStyleCalculator();
  const ceilingMode = useAppSelector(getActiveCeilingMode);

  useAutoInvalidateOnChange(ceilingMode, calculatedTrays);

  if (ceilingMode === 'none') return null;

  return (
    <LayoutCoordinateVisuals>
      {insertionTrayAndGeometry && (
        <CeilingTrayVisual
          trayAndGeometry={insertionTrayAndGeometry}
          style={getStyle(insertionTrayAndGeometry.tray)}
          mode={ceilingMode}
        />
      )}

      {calculatedTrays.map((trayAndGeometry) => (
        <CeilingTrayVisual
          key={'guid' in trayAndGeometry.tray ? trayAndGeometry.tray.guid : 'insertion'}
          trayAndGeometry={trayAndGeometry}
          style={getStyle(trayAndGeometry.tray)}
          mode={ceilingMode}
        />
      ))}
    </LayoutCoordinateVisuals>
  );
}
